<template>
    <section class="start-free-area">
        <div class="container">
            <div class="start-free-content" data-aos="fade-up">
                <div class="ritual-heading">
                    <span class="ritual-kicker">{{ $t('newsletter.ritualKicker') }}</span>
                    <h2 v-html="$t('newsletter.ctaTitle')"></h2>
                    <p v-html="$t('newsletter.ctaDesc')"></p>
                </div>
                <div class="feature-grid ritual-grid">
                    <div v-for="(step, index) in ritualSteps" :key="index" class="feature-point">
                        <span aria-hidden="true"></span>
                        <div>
                            <h3>{{ step.title }}</h3>
                            <p>{{ step.desc }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    computed: {
        ritualSteps() {
            return [0, 1, 2].map((index) => ({
                title: this.$t(`newsletter.ritualSteps.${index}.title`),
                desc: this.$t(`newsletter.ritualSteps.${index}.desc`)
            }))
        }
    }
}
</script>

<style scoped>
.start-free-area {
    background: #fff;
    padding: 76px 0;
}

.start-free-content {
    background: none;
    padding: 64px 60px;
}

.ritual-heading {
    margin: 0 auto 44px;
    max-width: 660px;
    text-align: center;
}

.ritual-kicker {
    color: var(--blue);
    display: block;
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 0.08em;
    margin-bottom: 16px;
    text-transform: uppercase;
}

.ritual-heading h2,
.ritual-heading > p {
    color: #111827;
}

.ritual-heading h2 {
    font-size: 42px;
    font-weight: 700;
    line-height: 1.25;
    margin-bottom: 14px;
}

.ritual-heading h2 ::v-deep strong {
    color: var(--blue3);
    font-style: italic;
    font-weight: 700;
}

.ritual-heading > p {
    font-size: 16px;
    line-height: 1.7;
    margin: 0;
    color: #48556a;
}

.ritual-grid {
    grid-template-columns: 1fr;
    margin: 0 auto;
    max-width: 660px;
}

@media (max-width: 767px) {
    .start-free-content {
        padding: 44px 24px;
    }

    .ritual-heading {
        margin-bottom: 34px;
    }

    .ritual-heading h2 {
        font-size: 32px;
    }

}

</style>
